import Swiper, {Autoplay, Navigation} from 'swiper';
import {swiperObserver} from '../../utils/swiper.utils.js';

const initializedWrappers = new WeakSet();

const initSpecialties = (scope = document) => {
  scope.querySelectorAll('.specialties-swiper-wr').forEach((el) => {
    if (initializedWrappers.has(el)) {
      return;
    }

    const swiperEl = el.querySelector('.swiper');
    const nextEl = el.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev');
    const cards = Array.from(el.querySelectorAll('[data-specialty-card]'));

    if (!swiperEl || !cards.length) {
      return;
    }

    initializedWrappers.add(el);

    const activeClass = 'is-active';
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    let swiper;

    const isClickLayout = () => window.innerWidth <= 1033 || !hoverQuery.matches;
    const isSlideControlledLayout = () => window.innerWidth <= 640;
    const getActiveCard = () => cards.find((card) => card.classList.contains(activeClass));

    const setActiveCard = (activeCard) => {
      if (!activeCard) {
        return;
      }

      cards.forEach((card) => {
        card.classList.toggle(activeClass, card === activeCard);
      });
    };

    const setActiveSlideCard = (instance) => {
      if (!isSlideControlledLayout() || !instance) {
        return;
      }

      const activeSlide = instance.slides[instance.activeIndex];

      if (activeSlide?.matches('[data-specialty-card]')) {
        setActiveCard(activeSlide);
      }
    };

    const syncActiveSlideState = (instance) => {
      const isMobile = isSlideControlledLayout();

      cards.forEach((card, index) => {
        card.classList.toggle('is-slide-active', isMobile && index === instance.activeIndex);
      });

      if (isMobile) {
        setActiveSlideCard(instance);
        return;
      }

      if (!getActiveCard()) {
        setActiveCard(cards[0]);
      }
    };

    cards.forEach((card) => {
      card.addEventListener('pointerenter', () => {
        if (!isClickLayout()) {
          setActiveCard(card);
        }
      });

      card.addEventListener('focusin', () => {
        if (!isClickLayout()) {
          setActiveCard(card);
        }
      });

      card.addEventListener('click', (event) => {
        if (!isClickLayout() || isSlideControlledLayout()) {
          return;
        }

        const isAlreadyActive = card.classList.contains(activeClass);

        if (!isAlreadyActive) {
          event.preventDefault();
          setActiveCard(card);
        }
      });
    });

    swiper = new Swiper(swiperEl, {
      modules: [Navigation, Autoplay],
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      threshold: 10,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        641: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        961: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        1100: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        init(instance) {
          syncActiveSlideState(instance);
        },
        slideChange(instance) {
          syncActiveSlideState(instance);
        },
        resize(instance) {
          syncActiveSlideState(instance);
        },
        breakpoint(instance) {
          syncActiveSlideState(instance);
        },
      },
    });

    swiperObserver(swiper);
    syncActiveSlideState(swiper);
  });
};

initSpecialties();
